import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const FRAME_W = 1270;
const FRAME_H = 720;

/**
 * Full-viewport safe-area checker — fixed 1270×720 box centered on screen.
 * Route: `/ad/safety-zone` (no app menu).
 */
export default function AdvertisementSafetyZonePage() {
    const [viewport, setViewport] = useState({ w: 0, h: 0 });

    useEffect(() => {
        const update = () => {
            setViewport({ w: window.innerWidth, h: window.innerHeight });
        };
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, []);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#1a1a1a",
                boxSizing: "border-box",
                overflow: "auto",
                p: 2,
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    width: FRAME_W,
                    height: FRAME_H,
                    flexShrink: 0,
                    boxSizing: "border-box",
                    border: "3px solid #00e676",
                    outline: "1px dashed rgba(255, 255, 255, 0.45)",
                    outlineOffset: 4,
                    bgcolor: "#263238",
                    boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.55)",
                }}
            >
                <Typography
                    component="span"
                    sx={{
                        position: "absolute",
                        top: 12,
                        left: 12,
                        color: "#00e676",
                        fontWeight: 700,
                        fontSize: "1.125rem",
                        letterSpacing: "0.04em",
                        userSelect: "none",
                    }}
                >
                    {FRAME_W} × {FRAME_H}
                </Typography>
                <Typography
                    component="span"
                    sx={{
                        position: "absolute",
                        bottom: 12,
                        right: 12,
                        color: "rgba(255, 255, 255, 0.7)",
                        fontSize: "0.875rem",
                        userSelect: "none",
                    }}
                >
                    Safe zone
                </Typography>
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        pointerEvents: "none",
                    }}
                >
                    <Typography
                        sx={{
                            color: "rgba(255, 255, 255, 0.35)",
                            fontWeight: 600,
                            fontSize: "2rem",
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            userSelect: "none",
                        }}
                    >
                        Content area
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    position: "fixed",
                    bottom: 16,
                    left: "50%",
                    transform: "translateX(-50%)",
                    px: 2,
                    py: 0.75,
                    borderRadius: 1,
                    bgcolor: "rgba(0, 0, 0, 0.75)",
                    color: "#fff",
                    fontSize: "0.8125rem",
                    userSelect: "none",
                    zIndex: 1,
                }}
            >
                Viewport: {viewport.w} × {viewport.h}
                {viewport.w < FRAME_W || viewport.h < FRAME_H ? " — scroll or resize to compare" : ""}
            </Box>
        </Box>
    );
}
